import {
  computeLineTotalForCartItemBase,
  computeModifiersPerUnit,
} from "@/domain/cart/cart.pricing"
import type { CartLine } from "@/store/cart/cart.types"
import { canonicalizeModifierGroups } from "@/store/cart/cart-line-identity"
import { cartLineToSelectedModifiers } from "@/store/cart/cart-line-adapters"

export function recalcCartLineTotals(line: CartLine): CartLine {
  const qty = Math.max(0, Math.floor(Number(line.quantity) || 0))
  const groups = canonicalizeModifierGroups(line.selected_modifiers)
  const modsForBase = cartLineToSelectedModifiers({ selected_modifiers: groups }, qty)
  const addonsTotal = computeModifiersPerUnit(modsForBase)
  const baseTotal = computeLineTotalForCartItemBase(line.item_price, qty, {
    selectedModifiers: modsForBase,
  })
  const comboTotal = (line.comboTotalPerUnit ?? 0) * qty
  const itemTotal = baseTotal + comboTotal
  return {
    ...line,
    quantity: qty,
    selected_modifiers: groups,
    addonsTotal,
    itemTotal,
  }
}
